// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZrmListingsPropertiesWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { FilterStatusType, ListingPropertiesResponseDto } from '../..';

interface ListParams {
  limit?: number;
  searchText?: string;
  startKeyExclusive?: string;
  status?: FilterStatusType;
}

export const RentalManagerAccountViewZrmListingsPropertiesWebApiHandler_list_Path =
  '/api/web/v2/users/accountView/zrm/listings/properties/list';

/**
 * Get zrm user account view property list grouped by address
 */
export const RentalManagerAccountViewZrmListingsPropertiesWebApiHandler_list = (
  getParams: ListParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ListParams, never, ListingPropertiesResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmListingsPropertiesWebApiHandler_list_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
